// extracted by mini-css-extract-plugin
export default {"fs":"_947a0740a4 d66e9c7b32"};